<template>
  <div v-if="visible" class="event_card_calendar">
    <div class="landing_slider" style="position: absolute; right: 30px; top: 10px;">
      <div ref="arrow_prev" class="slick-prev slick-arrow" :class="{'slick-disabled': !checkHasPreviousDay() || disabledPreviousDay}" @click="nextDayEvent('previous')" />
      <div ref="arrow_next" class="slick-next slick-arrow" :class="{'slick-disabled': !checkHasNextDay() || disabledNextDay}" @click="nextDayEvent('next')" />
    </div>
    <div class="event_card_calendar_body">
      <div class="close_event_calendar_view" @click="handleCloseEventCalendar()">
        <svg-icon name="black-close" />
      </div>
      <div class="event_card_calendar_left">
        <div class="event_calendar_left_header">
          <div class="event_calendar_left_time">
            <div class="event_calendar_left_month">
              {{ getMonth }}
            </div>
            <div class="event_calendar_left_day">
              {{ getDate }}
            </div>
          </div>
          <div class="event_calendar_month_actions">
            <div class="event_calendar_action" @click.stop.prevent="handleGoToMonth(1)">
              <svg-icon name="chevron-up" color="#000000" />
            </div>
            <div class="event_calendar_action" @click.stop.prevent="handleGoToMonth(2)">
              <svg-icon name="chevron-down" color="#000000" />
            </div>
          </div>
        </div>
        <div class="event_calendar_left_body">
          <event-card v-for="event in current_event_data" :key="event.id" :event="event" :theme="isLightTheme" />
          <div class="event_calendar_left_body_actions">
            <div class="light-theme-slick-arrow">
              <div>
                <div class="light_theme_arrow left slick-arrow" :class="{'slick-disabled': checkHasPreviousEvent() === 0}" @click="setCurrentEvent(checkHasPreviousEvent())" />
                <span>Previous Event</span>
              </div>
              <div>
                <span>Next Event</span>
                <div class="light_theme_arrow right slick-arrow" :class="{'slick-disabled': checkHasNextEvent() === 0}" @click="setCurrentEvent(checkHasNextEvent())" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="event_card_calendar_right">
        <event-landing-calendar
          :month="month"
          :year="year"
          :day="day"
          :timezone="timezone"
          :game="game_filter"
          :selected-item-id="parseInt(current_tournament_id)"
          :handle-get-data-for-month="getListEventCalendar"
          :handle-click-on-item="handleClickOnItem"
          @update-list-data="updateListEventCalendar"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import dayjs from '../../utils/dayjs';
import EventCard from './EventCard';
import EventLandingCalendar from '../calendar/landing-calendar';
import SvgIcon from '../shared/icons/index.vue';
import { EventBus, UPDATE_LIST_EVENT_CALENDAR, CLOSE_EVENT_CALENDAR, FILTER_CALANDAR_BY_GAME, EVENT_CALENDAR_FORCE_SHOW, CALENDAR_MARQUEES_SHOW_GRID } from '../../event-bus';

export default {
  components: { EventCard, EventLandingCalendar, SvgIcon },
  mixins: [component],
  props: {
    currentGameFilter: {
      type: String,
      default() {
        return 'all';
      },
    },
    visible: {
      type: String,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      list_event_calendar: {},
      list_tournament_id: [],
      list_event_load_data: {},
      current_event_data: [],
      current_tournament_id: 0,
      listMonthEvent: [],
      timezone: '',
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      day: new Date().getDate(),
      extendDay: {},
      monthData: {},
      daySelected: '',
      disabledNextDay: false,
      disabledPreviousDay: false,
      game_filter: 'all',
    };
  },
  computed: {
    getMonth() {
      return dayjs(new Date(this.year, this.month, 0)).format('MMMM YYYY');
    },
    getDate() {
      return dayjs(new Date(this.year, this.month - 1, this.day)).format('dddd, MMMM Do');
    },
  },
  created() {
    EventBus.$on(UPDATE_LIST_EVENT_CALENDAR, this.updateListEventCalendar);
    EventBus.$on(FILTER_CALANDAR_BY_GAME, (gameFilter) => {
      this.game_filter = gameFilter;
    });
    EventBus.$on(EVENT_CALENDAR_FORCE_SHOW, this.forceVisible);
    this.timezone = this.guessTimezone();
    this.game_filter = this.currentGameFilter;
  },
  beforeDestroy() {
    EventBus.$off(UPDATE_LIST_EVENT_CALENDAR);
    EventBus.$off(FILTER_CALANDAR_BY_GAME);
    EventBus.$off(EVENT_CALENDAR_FORCE_SHOW);
  },
  methods: {
    forceVisible() {
      if (!this.visible) {
        this.visible = true;
      }
    },
    updateCurrentEventId(eventId) {
      if (this.daySelected !== '') {
        this.setEventForDaySelect(this.daySelected);
      } else {
        this.setCurrentEvent(eventId);
      }
    },
    updateListEventCalendar(listEventCalendar, listExtendDay, monthData, eventId) {
      var self = this;
      this.extendDay = listExtendDay;
      this.monthData = monthData;
      this.updateCurrentEventId(eventId);
      this.list_event_calendar = {};
      this.list_tournament_id = [];
      this.list_event_calendar = Object.assign(this.list_event_calendar, listEventCalendar);
      Object.keys(this.list_event_calendar).forEach(function(timestamp) {
        Object.keys(self.list_event_calendar[timestamp]).forEach(function(tourId) {
          if (self.list_tournament_id.indexOf(tourId.toString()) === -1) {
            self.list_tournament_id.push(tourId);
          }
        });
      });
    },
    checkHasNextEvent() {
      var tourId = this.current_tournament_id;
      var tourIndex = this.list_tournament_id.indexOf(tourId.toString());
      if (tourIndex > -1 && typeof this.list_tournament_id[tourIndex + 1] !== 'undefined') {
        return this.list_tournament_id[tourIndex + 1];
      }
      return 0;
    },
    checkHasPreviousEvent() {
      var tourId = this.current_tournament_id;
      var tourIndex = this.list_tournament_id.indexOf(tourId.toString());
      if (tourIndex > -1 && typeof this.list_tournament_id[tourIndex - 1] !== 'undefined') {
        return this.list_tournament_id[tourIndex - 1];
      }
      return 0;
    },
    nextDayEvent(type) {
      if (type === 'previous') {
        this.changePreviousDay();
      } else if (type === 'next') {
        this.changeNextDay();
      }
    },

    changeNextDay() {
      this.disabledNextDay = true;
      this.disabledPreviousDay = true;
      var dayString = this.day < 10 ? '0' + this.day : this.day;
      var monthString = this.month < 10 ? '0' + this.month : this.month;
      var dateString = this.year + '-' + monthString + '-' + dayString;
      if (typeof this.extendDay[dateString] !== 'undefined' && typeof this.extendDay[dateString]['next_day'] !== 'undefined') {
        var nextDay = this.extendDay[dateString]['next_day'];
        var dateArr = nextDay.split('-');
        if (this.month !== parseInt(dateArr[1]) || this.year !== parseInt(dateArr[0])) {
          this.daySelected = nextDay;
        } else {
          this.setEventForDaySelect(nextDay);
        }
        this.day = parseInt(dateArr[2]);
        this.month = parseInt(dateArr[1]);
        this.year = parseInt(dateArr[0]);
      }
    },
    changePreviousDay() {
      this.disabledNextDay = true;
      this.disabledPreviousDay = true;
      var dayString = this.day < 10 ? '0' + this.day : this.day;
      var monthString = this.month < 10 ? '0' + this.month : this.month;
      var dateString = this.year + '-' + monthString + '-' + dayString;
      if (typeof this.extendDay[dateString] !== 'undefined' && typeof this.extendDay[dateString]['previous_day'] !== 'undefined') {
        var previousDay = this.extendDay[dateString]['previous_day'];
        var dateArr = previousDay.split('-');
        if (this.month !== parseInt(dateArr[1]) || this.year !== parseInt(dateArr[0])) {
          this.daySelected = previousDay;
        } else {
          this.setEventForDaySelect(previousDay);
        }

        this.day = parseInt(dateArr[2]);
        this.month = parseInt(dateArr[1]);
        this.year = parseInt(dateArr[0]);
      }
    },
    checkHasNextDay() {
      var dayString = this.day < 10 ? '0' + this.day : this.day;
      var monthString = this.month < 10 ? '0' + this.month : this.month;
      var dateString = this.year + '-' + monthString + '-' + dayString;
      if (typeof this.extendDay[dateString] !== 'undefined' && typeof this.extendDay[dateString]['next_day'] !== 'undefined') {
        return this.extendDay[dateString]['next_day'];
      }
      return false;
    },
    checkHasPreviousDay() {
      var dayString = this.day < 10 ? '0' + this.day : this.day;
      var monthString = this.month < 10 ? '0' + this.month : this.month;
      var dateString = this.year + '-' + monthString + '-' + dayString;
      if (typeof this.extendDay[dateString] !== 'undefined' && typeof this.extendDay[dateString]['previous_day'] !== 'undefined') {
        return this.extendDay[dateString]['previous_day'];
      }
      return false;
    },

    setCurrentEvent(tourId) {
      if (tourId === 0) {
        return;
      }
      this.current_tournament_id = tourId;
      this.loadEventCard();
    },
    setEventForDaySelect(daySelected) {
      this.current_tournament_id = this.monthData[daySelected][0]['id'];
      this.loadEventCard();
      this.daySelected = '';
    },
    async loadEventCard() {
      var tourId = this.current_tournament_id;
      if (typeof this.list_event_load_data[tourId] !== 'undefined') {
        this.current_event_data = this.list_event_load_data[tourId];
        this.day = parseInt(dayjs(this.list_event_load_data[tourId][0].calendar_date).format('D'));
        this.disabledNextDay = false;
        this.disabledPreviousDay = false;
        return;
      }
      await this.$http.get('/event/get_event_card', {
        params: {
          'tournament_id': tourId,
          'timezone': this.timezone,
        },
      })
        .then(response => {
          if (response.data.status === 0) {
            this.current_event_data = response.data.event_data;
            this.day = parseInt(dayjs(response.data.event_data[0].calendar_date).format('D'));
            this.list_event_load_data[tourId] = response.data.event_data;
          }
        })
        .catch(error => {
          console.log('search error request');
          console.log(error);
        }).finally(() => {
          this.disabledNextDay = false;
          this.disabledPreviousDay = false;
        });
    },

    async getListEventCalendar(startTime, endTime, month, year, game) {
      if (month && year && typeof this.listMonthEvent[month] !== 'undefined') {
        return this.listMonthEvent[year + '-' + month];
      }
      if (game === '') {
        game = 'all';
      }
      try {
        const res = await this.$http.get(this.routeGetListEventCalendar(), {
          params: {
            'game': game,
            'start_time': startTime,
            'end_time': endTime,
            'timezone': this.guessTimezone(),
            'month': month,
            'year': year,
          },
        });
        if (res.data.status === 0) {
          if (month && year) {
            this.listMonthEvent[year + '-' + month] = res.data;
          }
          this.$emit('list-game-filter-calendar', res.data.list_game_filter);
        }
        return res.data;
      } catch (error) {
        console.log(error);
      }
    },
    handleClickOnItem(data) {
      this.current_tournament_id = data.id;
      this.day = data.day;
      this.loadEventCard();
    },
    handleGoToMonth(status) {
      if (status === 1) {
        if (this.month === 1) {
          this.month = 12;
          this.year = this.year - 1;
        } else {
          this.month = this.month - 1;
        }
      } else if (status === 2) {
        if (this.month === 12) {
          this.month = 1;
          this.year = this.year + 1;
        } else {
          this.month = this.month + 1;
        }
      }
    },
    handleCloseEventCalendar() {
      EventBus.$emit(CLOSE_EVENT_CALENDAR);
      EventBus.$emit(CALENDAR_MARQUEES_SHOW_GRID);
    },
  },
};
</script>
<style lang="scss">
    @import "../../styles/landing/calendar.scss";
</style>
